const KeenSlider = window.KeenSlider

const { setInitialised, useDots, addWheelControls } =
  window.BAO.Carousel.plugins
const { debounce } = window.BAO.Utils

class USPsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    this.listeners.add(
      window,
      'resize',
      debounce(() => {
        this.setupCarousel()
      }, 500),
    )
  }

  setupCarousel () {
    if (window.BAO.MediaBreakpoints.isLg) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 901px)': {
            disabled: true,
          },
        },
      },
      [
        setInitialised(),
        useDots(this.els?.dot?.elements),
        addWheelControls('horizontal'),
      ],
    )
  }
}

if (!customElements.get('usps-carousel')) {
  customElements.define('usps-carousel', USPsCarousel)
}
